import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type NoticeLevel = 'info' | 'warning' | 'error';

@Component({
  selector: 'app-notice',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss'],
})
export class NoticeComponent {
  readonly level = input<NoticeLevel>('info');
  readonly iconName = input<string>('info');
  readonly title = input<string>();
  readonly cssClasses = input<string>();
  readonly content = input.required<string>();
}
